
/**
 * This file is auto-generated based on the icons presents in the @file `/apps/pwa/src/assets/icons` folder.
 * Please run the `npx nx sync-icons` command if you change the content of the icons folder. 
 */
export enum Icon {
  /** ![](../../../../../../../apps/pwa/src/assets/icons/action.svg) */
  action = "action",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/actions.svg) */
  actions = "actions",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/add.svg) */
  add = "add",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/agenda.svg) */
  agenda = "agenda",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/arrow-down.svg) */
  arrowDown = "arrow-down",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/arrow-left.svg) */
  arrowLeft = "arrow-left",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/arrow-right.svg) */
  arrowRight = "arrow-right",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/boat-step.svg) */
  boatStep = "boat-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/bookmark-filled.svg) */
  bookmarkFilled = "bookmark-filled",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/bookmark.svg) */
  bookmark = "bookmark",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/carret-down.svg) */
  carretDown = "carret-down",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/carret-right.svg) */
  carretRight = "carret-right",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/carret-up.svg) */
  carretUp = "carret-up",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/check.svg) */
  check = "check",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/checkup.svg) */
  checkup = "checkup",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/chest.svg) */
  chest = "chest",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/clock-circle.svg) */
  clockCircle = "clock-circle",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/close-arrow.svg) */
  closeArrow = "close-arrow",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/close.svg) */
  close = "close",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/collaborator.svg) */
  collaborator = "collaborator",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/comments.svg) */
  comments = "comments",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/conversations.svg) */
  conversations = "conversations",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/copilot.svg) */
  copilot = "copilot",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/copy.svg) */
  copy = "copy",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/dashboard.svg) */
  dashboard = "dashboard",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/delete.svg) */
  "delete" = "delete",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/down.svg) */
  down = "down",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/download.svg) */
  download = "download",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/edit-outlined.svg) */
  editOutlined = "edit-outlined",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/edit.svg) */
  edit = "edit",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/eye-filled.svg) */
  eyeFilled = "eye-filled",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/eye-invisible.svg) */
  eyeInvisible = "eye-invisible",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/eye.svg) */
  eye = "eye",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/filter.svg) */
  filter = "filter",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/glasses-step.svg) */
  glassesStep = "glasses-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/hand-step.svg) */
  handStep = "hand-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/heart-step.svg) */
  heartStep = "heart-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/help.svg) */
  help = "help",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/hr.svg) */
  hr = "hr",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/info.svg) */
  info = "info",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/left-circle.svg) */
  leftCircle = "left-circle",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/loading-invert.svg) */
  loadingInvert = "loading-invert",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/loading.svg) */
  loading = "loading",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/lock.svg) */
  lock = "lock",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/logo.svg) */
  logo = "logo",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/logout.svg) */
  logout = "logout",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/manager.svg) */
  manager = "manager",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/map-step.svg) */
  mapStep = "map-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/map.svg) */
  map = "map",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/menu.svg) */
  menu = "menu",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/minus.svg) */
  minus = "minus",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/motivations.svg) */
  motivations = "motivations",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/mountain-step.svg) */
  mountainStep = "mountain-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/plus.svg) */
  plus = "plus",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/profile.svg) */
  profile = "profile",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/puce.svg) */
  puce = "puce",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/question.svg) */
  question = "question",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/right-circle.svg) */
  rightCircle = "right-circle",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/select-arrow.svg) */
  selectArrow = "select-arrow",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/send.svg) */
  send = "send",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/share.svg) */
  share = "share",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/sidebar-menu-inverted.svg) */
  sidebarMenuInverted = "sidebar-menu-inverted",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/sidebar-menu.svg) */
  sidebarMenu = "sidebar-menu",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/sun-step.svg) */
  sunStep = "sun-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/talk.svg) */
  talk = "talk",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/task-list.svg) */
  taskList = "task-list",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/time.svg) */
  time = "time",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/timer.svg) */
  timer = "timer",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/training-outline.svg) */
  trainingOutline = "training-outline",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/training.svg) */
  training = "training",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/user-list.svg) */
  userList = "user-list",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/user.svg) */
  user = "user",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/w-logo.svg) */
  wLogo = "w-logo",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/walk-step.svg) */
  walkStep = "walk-step",
  /** ![](../../../../../../../apps/pwa/src/assets/icons/warning.svg) */
  warning = "warning"
}
